import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { getOne } from "@/api/contentful";
import { COOKIE_POLICY } from "@/data/consts";
import { LegalDocument } from "@/types/index";
import PageSEO from "@/components/Shared/PageSEO";
import HeaderContent from "@/components/Header/Article/HeaderContent";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

const Breadcrumbs = [
	{
		title: "Home",
		href: "/",
		active: false,
	},
	{
		title: "Cookie Policy",
		href: "/legal/cookie-policy",
		active: true,
	},
];

const CookiePolicy: React.FC<{
	data: LegalDocument;
}> = ({ data }) => {
	return (
		<div className="h-100 d-flex flex-column">
			<PageSEO
				title={"Cookie Policy | Consumer Choices"}
				description={"The Cookie Policy for Consumer Choices Website."}
				keywords={"Consumer Choices Cookie Policy"}
			/>
			<Header
				left={<HeaderContent title={"Cookie Policy"} />}
				right={<></>}
				breadcrumbs={Breadcrumbs}
			/>
			<section className="flex-grow-1 bg-blue">
				<div className="container d-flex flex-column flex-grow-1 pt-5 pb-5">
					{documentToReactComponents(data.fields.privacyPolicy)}
				</div>
			</section>
			<Footer />
		</div>
	);
};

export async function getStaticProps() {
	const data = await getOne(COOKIE_POLICY);

	return {
		props: {
			data,
		},
		revalidate: Number(process.env.REVALIDATE_CONTENTFUL),
	};
}

export default CookiePolicy;
